<script lang="ts">
    import KpUserInfoCard from '../../../../../../features/user/KpUserInfoCard.svelte';
    import type {User} from 'typings/portaro.be.types';

    export let value: User;

</script>

<template>
    <KpUserInfoCard user={value}/>
</template>